module.exports = __webpack_public_path__ + "static/img/harvest.7368821a.png";